import React, { useState, useEffect, useRef } from "react";

import logo from "images/logo.jpg";

const Header = () => {
	const [isActive, setIsActive] = useState(false);
	const ref = useRef(null);
	const [elementY, setElementY] = useState(null);

	useEffect(() => {
		if (ref.current) {
			setElementY(ref.current.getBoundingClientRect().top + window.scrollY);
		}
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			if (elementY !== null && window.scrollY >= elementY) {
				setIsActive(true);
			} else {
				setIsActive(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [elementY]);

	return (
		<header id="home" className="rts-header-area header-one">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="header--one-main">
							<div className="row align-items-center header-top-one">
								<div className="col-lg-2">
									<a href="/" className="logo-area">
										<img
											src={logo}
											alt="Logo TecnoCGE - Specialisti in cartongesso a Codogno, Lodi, Piacenza"
										/>
									</a>
								</div>
								<div className="col-lg-10">
									<div className="header-right-area">
										<div className="single-info-contact">
											<i className="fa-light fa-clock"></i>
											<div className="inner-content">
												<span>Sempre al tuo servizio</span>

												<h6 className="title">Da Lun a Ven: 9:00-17:00</h6>
											</div>
										</div>

										<div className="single-info-contact map">
											<i className="fa-light fa-location-dot"></i>
											<div className="inner-content">
												<span>Dove siamo</span>

												<h6 className="title">Via S. Ramelli 5, Codogno</h6>
											</div>
										</div>

										<div className="btn-area-header">
											<a href="#contact" className="rts-btn btn-primary with-arrow">
												Contattaci <i className="fa-regular fa-arrow-up-right"></i>
											</a>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-lg-12">
									<div
										ref={ref}
										className={`header-nav-area header--sticky ${isActive ? "sticky" : ""}`}>
										<div className="logo-md-sm-device">
											<a href="/" className="logo">
												<img
													src={logo}
													alt="Logo TecnoCGE - Specialisti in cartongesso a Codogno, Lodi, Piacenza"
												/>
											</a>
										</div>

										<div className="header-nav main-nav-one">
											<nav>
												<ul>
													<li className="nav-item">
														<a className="nav-link" href="#home">
															HOME
														</a>
													</li>
													<li className="nav-item">
														<a className="nav-link" href="#about">
															ABOUT
														</a>
													</li>
													<li className="nav-item">
														<a className="nav-link" href="#services">
															SERVIZI
														</a>
													</li>
													{/* <li className="nav-item">
														<a className="nav-link" href="#portfolio">
															PORTFOLIO
														</a>
													</li> */}
													<li className="nav-item">
														<a className="nav-link" href="#contact">
															CONTATTI
														</a>
													</li>
												</ul>
											</nav>
										</div>
										<div className="actions-area">
											<div
												className="menu-btn"
												id="menu-btn"
												onClick={() => {
													document.getElementById("anywhere-home").classList.add("bgshow");
													document.getElementById("side-bar").classList.add("show");
												}}>
												<svg
													width="20"
													height="16"
													viewBox="0 0 20 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<rect y="14" width="20" height="2" fill="#1F1F25" />
													<rect y="7" width="20" height="2" fill="#1F1F25" />
													<rect width="20" height="2" fill="#1F1F25" />
												</svg>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
